<template>
  <section v-bind:id="menuItem.anchor" class="p-90-0-60">
    <div class="container">
      <div class="row">

        <div class="col-12 mb-30 align-self-center">
          <h2 class="light dark mb-30">{{menuItem.name}} <span class="bold">{{menuItem.nameBold}}</span></h2>
        </div>
      </div>
    </div>
    <div v-if="!showDummy">
      <iframe v-bind:src="collection.googleMapsUrl" width="100%" height="600px" frameborder="0" allowfullscreen></iframe>
    </div>
    <div v-else class="mapDummy" :style="'background-image: url(\'' + baseUrl + collection.placeholderImage.path + '\');'" v-on:click="showMap()">
      <div class="overlay">

          <div class="main-title text-center p-5">
            <!-- Main title -->
            <h1 class="light mb-15">{{collection.disclaimerText}}</h1>
            <h3 class="light opas mb-30">{{collection.disclaimerSubText}}</h3>
          </div>

      </div>
    </div>
  </section>
</template>

<script>
  export default {
    components: {
    },
    data () {
      return {
        collection: {'disclaimerText': 'Klicken Sie hier, um die Karte anzuzeigen', 'googleMapsUrl': 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d5028.937686079963!2d6.939149657672119!3d50.93354190814153!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47bf2501dd2daf01%3A0xcb316be024f90f51!2sBeethovenstra%C3%9Fe+10%2C+50674+K%C3%B6ln!5e0!3m2!1sde!2sde!4v1549620751483', 'placeholderImage': {'path': '/cockpit/storage/uploads/2019/03/13/5c8930a5609d6blurred_map.jpg'}, 'disclaimerSubText': 'Damit stimmen Sie zu, dass Ihr Browser die Kartendaten von Google lädt, ihre IP Adresse Google bekannt wird, und dass Cookies für die Verwendung der Karte gespeichert werden.', '_mby': '5c78dbb16435630838000192', '_by': '5c78dbb16435630838000192', '_modified': 1552495947, '_created': 1552494775, '_id': '5c8930b76634360ed200026c'},
        showDummy: true,
        dummyUrl: '/static/img/blurred_map.jpg'
      }
    },
    props: ['menuItem'],
    computed: {
      baseUrl () {
        return this.$store.getters.baseUrl()
      }
    },
    mounted () {
      this.$http.get(this.$store.getters.serviceClient().getCollectionUrl(this.$props.menuItem.collection))
        .then((response) => {
          if (response.ok) {
            console.log(response.body.entries)
            this.$data.collection = response.body.entries[0]
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    methods: {
      showMap: function (event) {
        this.showDummy = false
      }
    }
  }
</script>

<style scoped="scoped">
  iframe {
    border:0
  }
  #map div {
    width: 100%;
    position: relative;
  }
  .mapDummy {
    height:600px;
    background-size: cover;
    background-position: center;
    background-color: transparent;
    display:block;
  }

  h1 {
    font-family: 'Roboto Slab', serif;
    opacity: 1;
    transform: translateY(0px);
  }
  h3 {
    font-family: 'Raleway', sans-serif;
    opacity: 1;
    transform: translateY(0px);
    font-size: 1.5em;
    font-weight: 300;
  }
  .mapDummy .overlay {
    display: -webkit-box;
    display: -ms-flexbox;
    /*display: flex;*/
    -ms-flex-line-pack: center;
    -ms-flex-pack: center;
    align-content: center;
    -webkit-box-pack: center;
    justify-content: center;
    padding-top: 0px;
    height: 50vh;
    align-items:center;
    /*width: 100vw;*/
  }

  .mapDummy .container {
    -ms-flex-item-align: center;
    align-self: center;
  }

</style>



// WEBPACK FOOTER //
// src/components/sections/Map.vue